// The report surface's one rule for writing a URL-synced control value.
//
// Choosing the value a screen already shows with no parameters at all DELETES
// the parameter instead of writing it. Two URLs for one screen would make
// "is this the default?" unanswerable from the address bar, and would leave
// shared links carrying state their author never chose.
//
// Reading is the mirror rule and lives with each control's owner: an
// unrecognised value falls back for rendering but is NOT rewritten, so a typo
// in a shared link stays visible to whoever can fix it.
//
// Shared by the view and range controls on the Reports tab and the delivery
// report's record-type filter, so the three cannot drift.

export function nextReportParams(
  current: URLSearchParams,
  key: string,
  value: string,
  defaultValue: string,
): URLSearchParams {
  const next = new URLSearchParams(current);
  if (value === defaultValue) {
    next.delete(key);
  } else {
    next.set(key, value);
  }
  return next;
}
